module.exports = __webpack_public_path__ + "static/gallery48-c7290a5f36cf8a523f11ef5036a55db4.png";